export default __webpack_public_path__ + "static/media/gw200-6.2c1644e0.png";